import React, { ReactNode } from 'react';
import {
  ContentWrapper,
  PrefixWrapper,
  StatisticWrapper,
  SuffixWrapper,
  TitleWrapper,
  ValueWrapper,
} from './statistic.styles';

export interface StatisticProps {
  title?: ReactNode;
  value?: string | number;
  prefix?: ReactNode;
  suffix?: ReactNode;
  precision?: number;
  decimalSeparator?: string;
  direction?: 'row' | 'column';
  align?: 'left' | 'right' | 'center';
}

const formatValue = (
  value: string | number | undefined,
  precision?: number,
  decimalSeparator?: string,
): string => {
  if (value === undefined || value === null) {
    return '';
  }

  let formattedValue = typeof value === 'number' ? String(value) : value;

  if (typeof value === 'number' && precision !== undefined) {
    formattedValue = value.toFixed(precision);
  }

  const parts = formattedValue.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  formattedValue = parts.join('.');

  if (decimalSeparator && formattedValue.includes('.')) {
    formattedValue = formattedValue.replace('.', decimalSeparator);
  }

  return formattedValue;
};

export const Statistic: React.FC<StatisticProps> = ({
  title,
  value,
  prefix,
  suffix,
  precision,
  decimalSeparator = '.',
  direction = 'row',
  align = 'left' as const,
}) => {
  const formattedValue = formatValue(value, precision, decimalSeparator);

  return (
    <StatisticWrapper direction={direction} align={align}>
      {title && <TitleWrapper variant="caption">{title}</TitleWrapper>}
      <ContentWrapper>
        {prefix && <PrefixWrapper>{prefix}</PrefixWrapper>}
        <ValueWrapper>{formattedValue}</ValueWrapper>
        {suffix && <SuffixWrapper>{suffix}</SuffixWrapper>}
      </ContentWrapper>
    </StatisticWrapper>
  );
};
